import { getAnalytics, logEvent } from 'firebase/analytics';

export const gaLogEvent = (eventName, params) => {
  const analytics = getAnalytics();
  logEvent(analytics, eventName, params);
};
